import PropTypes from 'prop-types'
import { Icon } from '@artprov/design-system'
import { cn } from '../../_utils/cn'
import { menuVariants } from '../variants/Menu.variants'

/**
 * Botón trigger del Nivel 1. Abre/cierra el panel al hacer clic.
 * Incluye chevron que rota 180° cuando está abierto o seleccionado.
 * Muestra un indicador inferior cuando fue seleccionado.
 * @param {Object} props
 * @param {string} [props.id]
 * @param {string} [props.label]
 * @param {boolean} [props.isOpen]
 * @param {boolean} [props.isSelected]
 * @param {string} [props.className]
 * @param {string} [props.dataTestId]
 * @param {string} [props.panelId]
 * @param {() => void} [props.onClick]
 */
export const MenuTrigger = ({
  id,
  label,
  isOpen = false,
  isSelected = false,
  className,
  dataTestId,
  panelId,
  onClick,
}) => {
  const chevronUp = isOpen || isSelected

  return (
    <button
      id={id}
      type="button"
      aria-haspopup="menu"
      aria-expanded={isOpen}
      aria-controls={panelId}
      onClick={onClick}
      data-testid={dataTestId}
      className={cn(menuVariants.trigger({ isOpen }), className)}
    >
      <span>{label}</span>
      <span
        data-open={chevronUp}
        className={cn(
          'inline-flex size-4 shrink-0 items-center justify-center text-primary-10 transition-transform duration-200',
          chevronUp ? 'rotate-180' : ''
        )}
        aria-hidden="true"
      >
        <Icon icon="keyboard_arrow_down" size="small" />
      </span>
    </button>
  )
}

MenuTrigger.displayName = 'MenuTrigger'

MenuTrigger.propTypes = {
  id: PropTypes.string,
  label: PropTypes.string,
  isOpen: PropTypes.bool,
  isSelected: PropTypes.bool,
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  panelId: PropTypes.string,
  onClick: PropTypes.func,
}
